var _defs, _rect, _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1142({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 4.4,
    width: 15,
    height: 7.2,
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.73,5.5H3a.51.51,0,0,0-.51.5V7.5h1a.5.5,0,1,1,0,1h-1V10a.51.51,0,0,0,.51.5h7.78a2.4,2.4,0,0,0,2.41-2.38V7.88A2.4,2.4,0,0,0,10.73,5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.44,7.5h-.6a.5.5,0,1,0,0,1h.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.44,8.5h1a.5.5,0,1,0,0-1h-1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 4.97,
    cy: 8,
    rx: 0.5,
    ry: 0.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1142);
export default __webpack_public_path__ + "static/media/Symbolpack_1_142.f6f5d92dc1d4f662c532d3ac09ceb1f0.svg";
export { ForwardRef as ReactComponent };